module.exports = __webpack_public_path__ + "static/media/sort.d53c20f0.svg";